import React, { useEffect, useState } from "react";
import "./HomePages.css";
import { Link } from "react-router-dom";
import displayName from "../components/Navbar"
import { doc, onSnapshot } from "firebase/firestore";
import { auth } from "../firebase/auth";
import { db } from "../firebase/firestore";
import { useCurrentUser } from "../components/useCurrentUser";
import { HeroSection } from "../components/HeroSection";
import { Countdown } from "../components/Countdown";
import heroImage from "../assets/images/portrett_solastrand.jpg";
// import heroImage from "../assets/images/portrett_paa_fjell.jpeg";
import heroImageAvslutning from "../assets/images/posering_i_par.jpeg";
// import hero1 from "../assets/images/ME_i_vann.jpeg";
import hero2 from "../assets/images/posering_i_par.jpeg";
// import hero3 from "../assets/images/hero_hatsOnBuss.jpeg";
import hero3 from "../assets/images/Whistler.jpeg";
import hero1 from "../assets/images/portrett_paa_fjell.jpeg";

const Home: React.FC = () => {
  const { displayName } = useCurrentUser();
  const heroImages = [hero1, hero2, hero3];

  return (
    <div className="home-page">
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-overlay">
          <div className="hero-text">
            <h1>30 05 26</h1>
            <p>MARTHE ELISE & OSCAR</p>
            {/* <p><Countdown targetDate="2026-05-30T12:00:00Z" /></p> */}
          </div>
        </div>
      </section>
            {/* <HeroSection
        images={heroImages}
        interval={5000}
        targetDate="2026-05-30T12:00:00Z"
        heading="DATE"
        subheading="HEADER"
        /> */}

      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      {/* BRUDEPARETS HJØRNE */}
      <section className="info-section">
        <div className="info-box">
          <h2>Velkommen! </h2>
            <p>Hei, og så hyggelig at du vil feire denne dagen med oss {displayName}! Ta gjerne kontakt om noe er uklart. Marthe Elise +47 928 64 234 / Oscar +47 481 72 166</p>
            <ul>
              <p><b>Sist oppdatert 27. mai</b></p>
              <li>1. mars: Gavelister lagt til.</li>
              <li>4. mai: Oppdaterte tider for sendeskjema lagt til.</li>
              <li>27. mai: Oppdaterte tider for sendeskjema lagt til.</li>
            </ul>     
        </div>
      </section>
      <section className="info-section">
        {/* FRISTER */}
        {/* FRISTER */}
        {/* FRISTER */}
        {/* FRISTER */}
        {/* FRISTER */}
        {/* FRISTER */}
        {/* FRISTER */}
        {/* FRISTER */}
        <div className="info-box">
          <h2>Frister</h2>
          <ul>
            <li>
              <p><b>Allergier</b>: Gi beskjed til brudeparet innen 1. april.</p>
            </li>
            <li>
              <p><b>Transport fra kirken</b>: Gi beskjed til brudeparet innen 1. april.</p>
            </li>
            <li>
              <p><b>Mingling på fredag</b>: Gi beskjed til brudeparet innen 26. april.</p>
            </li>
            <li>
              <p><b>Taler</b>: Gi beskjed til brudeparet innen 26. april. Vi ber om at taler begrenses til 4 minutter.</p>
               {/* Gi beskjed til toastmastere om dere skal tale, senest innen 26. april. Toastmastere er Rikke & Kjell Ivar Smedbøl, +47 480 90 614 / +47 922 20 477. Brudeparet. */}
            </li>
          </ul>
        </div>
        {/* GENERELL INFORMASJON */}
        {/* GENERELL INFORMASJON */}
        {/* GENERELL INFORMASJON */}
        {/* GENERELL INFORMASJON */}
        {/* GENERELL INFORMASJON */}
        {/* GENERELL INFORMASJON */}
        {/* GENERELL INFORMASJON */}
        {/* GENERELL INFORMASJON */}
        <div className="info-box">
          <h2>Generell informasjon</h2>
          <p>Vielsen vil skje i <a href="https://www.visitnorway.no/listings/stavanger-domkirke/14665/">Stavanger Domkirke</a>, og feiringen blir
            på <a href="https://www.solastrandhotel.no">Sola Strand Hotell</a>. Fra kirken organiserer vi transport til hotellet for de som ønsker det.</p>
          <ul>
            <li>
              <p><b>Rabatt (Hotell)</b>: Sola Strand Hotell tilbyr 20% rabatt på overnatting ifm brylluppet. Ingen kode, bare si at dere skal til oss.</p>
            </li>
            <li>
              <p><b>Parkering</b>: Parkeringsplassen til Sola Strand Hotell er administrert av <a href="https://onepark.no/autopay/">OnePark</a>. Enkleste betaling gjøres gjennom appene "Autopay" eller "Easypark".
              </p>
            </li>
            <li>
              <p><b>Bilder</b>: En fotograf vil følge oss frem til bordsettingen. Dersom dere tar bilder gjennom dagen, spesielt fra bordsettingen og utover, så håper vi dere kan dele de med oss i ettertid. Ber om at dere tar hensyn til at bilder ikke deles på sosiale medier uten tillatelse fra de i bildet.</p>
            </li>
          </ul>
        </div>
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        {/* SENDESKJEMA */}
        <div className="info-box">
          <h2>Sendeskjema</h2>
          <p><b>Fredag 29. mai <br /> 
                Kleskode sommerlig</b></p>
          <ul>
            <li><b>18:00</b>: Uformell mingling med pizza hos Brudens familie, for de som vil og har anledning. <br /> Adressen er Ragnhildsgate 72, 4044 Hafrsfjord.</li>
          </ul>
          <br />
          <p><b>Lørdag 30. mai <br /> 
                Smoking / Mørk dress / Kjole</b></p>
          <ul>
            <li><b>12:30</b>: Kirkedørene åpner.</li>
            <li><b>13:00</b>: Vielsen starter.</li>
            <li><b>14:00</b>: Transport til Sola Strand hotell (for påmeldte). Bussen går fra Kongsgård skole, holdeplassen ut kirketrappen og til venstre</li>
            <li><b>14:45</b>: Enkel servering, fingermat og bobler på hotellet (Axel Lunds Stue), mens brudeparet løper rundt på photoshoot.</li>
            <li><b>18:00</b>: Bordsetting.</li>
            <li><b>22:00</b>: Kaffe og kaker, sklir over til fest!</li>
            <li><b>23:30</b>: Nattmat, for å holde festen gående! </li>
            <li><b>02:00</b>: Rosignal, fest må avsluttes eller flyttes.</li>
          </ul>
        </div>
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        {/* GAVELISTE */}
        
        <div className="info-box">
          <h2>Gavelister</h2>
          {/* <p>DE ER TIGLJENGELIGE ALLEREDE NÅ, FOR SPESIELT INTERESSERTE UTVIKLERE</p> */}
          <p>De vil mulig bli oppdatert med flere ønsker etterhvert.</p>
          <ul>
            <li><a href="https://www.illumsbolighus.no/onskeliste/andre?id=d80c9ed3712aebcc9468a17258">Illums Bolighus</a>.</li>
            <li><a href="https://www.cg.no/apps/giftregistry/registry/415918?_r=1&utm_source=gift_reggie&utm_medium=gift_reggie&utm_campaign=gift_reggie&utm_content=415918">Christiania Glassmagasin</a>.</li>
            <li><a href="https://www.kitchn.no/onskeliste/245419/">Kitch`n</a>.</li>
            <li><a href="https://www.designforevig.no/bryllupslister/675088">Brødrene Pedersen.</a></li>
          </ul>
        </div>

        {/* TRIVIA */}
        {/* TRIVIA */}
        {/* TRIVIA */}
        {/* TRIVIA */}
        {/* TRIVIA */}
        {/* TRIVIA */}
        {/* TRIVIA */}
        {/* TRIVIA */}
        {/* <div className="info-box">
          <h2>Trivia</h2>
          <ul>
          <li><b>Kirken</b>: text .....................</li>
          <li><b>Prekerstolen</b>: text .....................</li>
          <li><b>Sola Airshow</b>: text .....................</li>
          <li><b>Stavanger by</b>: text .....................</li>
          </ul>
          </div> */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        {/* AVSLUTTENDE BILDE */}
        <div className="info-box">
          <section
            className="hero-section"
            style={{ backgroundImage: `url(${heroImageAvslutning})` }}
          >
          </section>
        </div>
        {/* <div className="info-box">
            <HeroSection
            images={heroImages}
            interval={5000}
            targetDate="2026-05-30T12:00:00Z"
            heading="DATE"
            subheading="HEADER"
            />
            </div> */}
      </section>
      <footer>
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        {/* AVSLUTTENDE TEXT */}
        <section
          className="hero-section"
          style={{ backgroundColor: "black" }}
        >
          <div className="hero-overlay">
            <div className="hero-text">
              <p><Countdown targetDate="2026-05-30T12:00:00Z" /></p>
              <p>...til bruden rusler nedover midtgangen🥂🥂</p>
            </div>
          </div>
        </section>
      </footer>
    </div>
  );
};

export default Home;
